// Shared style template catalog used by both the Result page and the Style page.
import indianEthnic from "@/assets/outfit-templates/indian-ethnic.webp";
import indoWestern from "@/assets/outfit-templates/indo-western.webp";
import asianStreetwear from "@/assets/outfit-templates/asian-streetwear.webp";
import kdrama from "@/assets/outfit-templates/kdrama.webp";
import westernCasual from "@/assets/outfit-templates/western-casual.webp";
import formal from "@/assets/outfit-templates/formal.webp";
import beach from "@/assets/outfit-templates/beach.webp";
import weddingGuest from "@/assets/outfit-templates/wedding-guest.webp";

export interface OutfitTemplate {
  id: string;
  label: string;
  emoji: string;
  prompt: string;
  image: string;
}

export const OUTFIT_TEMPLATES: OutfitTemplate[] = [
  {
    id: "indian-ethnic",
    label: "Indian Ethnic",
    emoji: "🪔",
    image: indianEthnic,
    prompt:
      "Traditional Indian ethnic look — kurta/sherwani or saree/lehenga as appropriate, rich fabrics (silk, cotton), intricate embroidery, dupatta or stole, ethnic footwear (mojari/juttis), subtle jewelry. Festive yet elegant.",
  },
  {
    id: "indo-western",
    label: "Indo-Western",
    emoji: "✨",
    image: indoWestern,
    prompt:
      "Indo-western fusion — modern silhouettes blended with Indian elements (nehru jacket, bandhgala, embroidered accents, kurta with jeans, dhoti pants with crop top). Contemporary and stylish.",
  },
  {
    id: "asian-streetwear",
    label: "Asian Street",
    emoji: "🏙️",
    image: asianStreetwear,
    prompt:
      "Tokyo/Seoul streetwear — oversized layering, techwear influences, cargo pants, statement sneakers, minimalist palette with one bold accent, baseball cap or bucket hat.",
  },
  {
    id: "kdrama",
    label: "K-Drama Chic",
    emoji: "🌸",
    image: kdrama,
    prompt:
      "K-drama inspired soft chic — tailored coat or cardigan, neutral knit, pleated skirt or wide trousers, loafers, soft pastel palette, clean and polished romantic aesthetic.",
  },
  {
    id: "western-casual",
    label: "Western Casual",
    emoji: "👖",
    image: westernCasual,
    prompt:
      "Western smart casual — well-fitted denim or chinos, crisp tee or button-down, leather sneakers or boots, minimal accessories, clean American/European fit.",
  },
  {
    id: "formal",
    label: "Formal",
    emoji: "🎩",
    image: formal,
    prompt:
      "Sharp formal look — tailored suit or blazer with dress trousers, crisp shirt, polished oxfords/heels, minimal jewelry, business or evening event ready.",
  },
  {
    id: "beach",
    label: "Beach Vibes",
    emoji: "🏖️",
    image: beach,
    prompt:
      "Beach/resort look — linen shirt or flowy dress, light shorts or wide pants, sandals or espadrilles, sunglasses, breezy summer palette of whites/blues/sand.",
  },
  {
    id: "wedding-guest",
    label: "Wedding Guest",
    emoji: "💐",
    image: weddingGuest,
    prompt:
      "Wedding guest outfit — semi-formal elegant, jewel tones or pastels, dressy footwear, tasteful accessories, photogenic and celebration-appropriate.",
  },
];
